module.exports = __webpack_public_path__ + "img/hkoig-white.924b608a.png";